module.exports = __webpack_public_path__ + "img/MEDIA026.2f434678.jpg";